/*-- import aliases -----------
'!/...' -> project root
'~/...' -> js folder root
-----------------------------*/
import { setup } from "~/core";
setup();

// import "~/global/_body";
import "~/global/_header";
import "~/global/multisite/_footer";
import "~/global/_siteModals";
import "~/global/_siteSearch.js";

import "~/components/multisite/_accordion";
import "~/components/multisite/_cookienotice";
import "~/components/multisite/_listtools";
import "~/components/multisite/_blueform";
import "~/components/_masonryGrid";
import "~/components/_mapMarker";
import "~/components/_listItems";
import "~/components/multisite/_illegalDumpingReport";
import "~/components/multisite/_illegalDumpingReportList";
import "~/components/multisite/_illegalDumpingReportAdmin";
import "~/components/multisite/_jurisdictionContactList";
import "~/components/multisite/_interiorVideoRail";
// import "~/components/_forms";
